export default __webpack_public_path__ + "static/media/copy.a91429a3.svg";